module.exports = __webpack_public_path__ + "static/media/logo-imprint.e0e97051.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-imprint.svg
// module id = 108
// module chunks = 0